import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import getFocusedFilterForTable from 'mini-mail-list-store/lib/utils/getFocusedFilterForTable';
import getFocusedInboxRollupStore from 'mini-mail-focused-inbox-rollup-store/lib/store/store';
import InboxViewType from 'owa-service/lib/contract/InboxViewType';
import isValidRollupStore from 'mini-mail-focused-inbox-rollup-store/lib/utils/isValidRollupStore';
import TableView from 'mini-mail-list-store/lib/store/schema/TableView';
/**
 * Determines whether to show focused other rollup
 * @param tableView table view
 */
export default function shouldShowStickyFocusedRollup(tableView: TableView): boolean {
    if (!tableView) {
        return false;
    }

    const focusedViewFilter = getFocusedFilterForTable(tableView);
    return (
        isValidFocusedViewFilter(focusedViewFilter) && isRollupStoreReadyForView(focusedViewFilter)
    );
}

const isValidFocusedViewFilter = (focusedViewFilter: FocusedViewFilter) =>
    focusedViewFilter === FocusedViewFilter.Focused ||
    focusedViewFilter === FocusedViewFilter.Other;

const isRollupStoreReadyForView = (focusedViewFilter: FocusedViewFilter) => {
    const focusedInboxRollupStore = getFocusedInboxRollupStore();
    return (
        isValidRollupStore() &&
        !focusedInboxRollupStore.isRollupDismissed &&
        areViewTypesDifferent(focusedInboxRollupStore.viewType, focusedViewFilter)
    );
};

/**
 * InboxViewType and FocusedViewFilter should be different in order to show up in the UI i.e,
 * -> If FocusedViewFilter.Focused is the current view filter in inbox then,
 *     InboxViewType.ClutterView should be the view type in the rollup store.
 * -> If FocusedViewFilter.Other is the current view filter in inbox then,
 *     InboxViewType.Focused should be the view type in the rollup store.
 *
 * Note: Doing this ensures that the rollup UI is for new unread messages in the 2nd inbox i.e,
 *       when in Focused, rollup should announce about new unread messages in other and vice-versa.
 */
const areViewTypesDifferent = (viewType: InboxViewType, focusedViewFilter: FocusedViewFilter) =>
    (viewType === InboxViewType.FocusedView && focusedViewFilter === FocusedViewFilter.Other) ||
    (viewType === InboxViewType.ClutterView && focusedViewFilter === FocusedViewFilter.Focused);
